module.exports = {
  layouts:
    [
      //Streams
      {
        name: 'Carousel - Portrait',
        description: 'A carousel scroll of Streams with portrait thumbnails. Displays the most number of Streams per screen when compared to Carousel - Landscape.',
        note: 'You can add as many Streams as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '236 * 315 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: 'Section 1',
              contents: [],
              type: 'carousel_portrait',
              entityType: 'stream',
              layoutStyle: 'carousel',
              cardStyle: 'large',
              smartFilter: 'recently_viewed_streams'
            }
          }]
        }
      },
      {
        name: 'Carousel - Landscape',
        entityType: 'stream',
        description: 'A carousel scroll of Streams with landscape thumbnails. Highlights the thumbnail designs for a visually rich experience.',
        note: 'You can add as many Streams as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '236 * 102 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              entityType: 'stream',
              contents: [],
              type: 'carousel_landscape',
              layoutStyle: 'carousel',
              cardStyle: 'small',
              smartFilter: 'recently_viewed_streams'
            }
          }]
        }
      },

      //Collections
      {
        name: 'Carousel',
        description: 'A carousel scroll of Collections with landscape thumbnails. Highlights the thumbnail designs for a visually rich experience.',
        note: 'You can add as many Collections as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '193 * 135 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              entityType: 'collection',
              type: 'collections_carousel',
              layoutStyle: 'carousel',
              cardStyle: 'small',
              smartFilter: 'my_collections'
            }
          }]
        }
      },
      {
        name: 'Promoted Content',
        description: 'Spotlight your prime-time content and ensure it stands tall and strong.',
        note: 'We recommend you to choose a Collection of your choice you\'d like to promote.',
        detailImage: "",
        icon: "",
        dimensions: '',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "",
              contents: [],
              type: 'promoted_content__',
              entityType: 'collection',
              layoutStyle: 'promoted_content',
              cardStyle: 'small',
            }
          }]
        }
      },

      //Assets
      {
        name: 'Carousel',
        description: 'A carousel scroll of Assets with portrait thumbnails.',
        note: 'You may add as many Assets as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '128 * 150 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: 'assets_carousel',
              entityType: 'asset',
              layoutStyle: 'carousel',
              cardStyle: 'small',
              smartFilter: 'most_viewed_assets'
            }
          }]
        }
      },

      {
        name: 'Promoted Content',
        description: 'Spotlight your prime-time content and ensure it stands tall and strong',
        note: 'We recommend you to choose an Asset of your choice you\'d like to promote.',
        detailImage: "",
        icon: "",
        dimensions: '',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "",
              contents: [],
              type: 'promoted_content__',
              entityType: 'asset',
              layoutStyle: 'promoted_content',
              cardStyle: 'small',
            }
          }]
        }
      },

      {
        name: 'Metro Combination',
        description: 'One Asset is highlighted as an Info Card while the others are displayed as smaller thumbnails around it. Ideal for a group of Assets that are related.',
        detailImage: "",
        note: 'Recommended number of Assets to display in this section is 4.',
        icon: "",
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: 'metro_combination',
              entityType: 'asset',
              layoutStyle: 'metro',
              cardStyle: 'small',
              smartFilter: 'most_viewed_assets'
            }
          }]
        }
      },
      {
        name: 'Info Cards',
        description: ' A descriptive snapshot of Assets with portrait thumbnails. Provides a helpful summary of the Assets and enables easy discovery.',
        note: 'Recommended number of Assets to display in each section is 3.',
        detailImage: "",
        icon: "",
        data: {
          columns: [{
            width: 1,
            section: {
              title: "Section 1",
              contents: [],
              type: 'assets_two_column_list',
              entityType: 'asset',
              layoutStyle: 'list',
              cardStyle: 'small',
              smartFilter: 'most_viewed_assets'
            } 
          }, {
            width: 1,
            section: {
              title: "Section 2",
              contents: [],
              type: 'assets_two_column_list',
              entityType: 'asset',
              layoutStyle: 'list',
              cardStyle: 'small',
              smartFilter: 'most_viewed_assets'
            }
          }]
        }
      },
    ]
};

